var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 2,
    fill: "#232F6A",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13109_52169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2662 19.8576V22.5413C17.2662 22.8467 17.1069 22.9995 16.7885 22.9995H14.5508C14.2155 22.9995 14.0479 22.8395 14.0479 22.5195V19.8795C14.0479 19.5886 14.2155 19.4431 14.5508 19.4431H16.7885C17.1069 19.4431 17.2662 19.5813 17.2662 19.8576ZM17.241 16.9995V17.5667C17.241 17.8722 17.065 18.0249 16.713 18.0249H14.7268C14.3748 18.0249 14.1988 17.8722 14.1988 17.5667V16.9776C14.1988 16.4976 14.2909 16.1122 14.4753 15.8213C14.6597 15.5158 14.9698 15.2104 15.4056 14.9049L16.8136 13.9013C17.35 13.5376 17.6182 13.1376 17.6182 12.7013V12.5704C17.6182 12.1195 17.4925 11.7995 17.241 11.6104C17.0064 11.4067 16.6125 11.3049 16.0593 11.3049H15.6068C15.0871 11.3049 14.71 11.3995 14.4753 11.5886C14.2574 11.7776 14.1485 12.1049 14.1485 12.5704V13.0286C14.1485 13.3486 13.9725 13.5086 13.6205 13.5086H11.4833C11.1313 13.5086 10.9553 13.3486 10.9553 13.0286V12.5267C10.9553 11.3922 11.3157 10.5195 12.0365 9.90855C12.7572 9.29764 13.7797 8.99219 15.1039 8.99219H16.5873C17.9115 8.99219 18.934 9.29764 19.6548 9.90855C20.3755 10.5195 20.7359 11.3922 20.7359 12.5267V12.8322C20.7359 13.5449 20.3588 14.1849 19.6045 14.7522L17.8948 15.9522C17.4589 16.3013 17.241 16.6504 17.241 16.9995Z",
    fill: "#232F6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13109_52169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 15,
    fill: "white",
    transform: "translate(10 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.55c6946340023538433a73148c0a99c4.svg";
export { ForwardRef as ReactComponent };